export default "__VITE_ASSET__60708c6e__"